import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerDayOneServiceWorker } from "@/lib/registerServiceWorker";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

registerDayOneServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

const splash = document.getElementById("app-splash");
if (splash) {
  const dismiss = () => {
    splash.classList.add("is-hidden");
    window.setTimeout(() => splash.remove(), 350);
  };
  window.requestAnimationFrame(() => window.requestAnimationFrame(dismiss));
  window.setTimeout(() => splash.isConnected && dismiss(), 4000);
}
